let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fsDjk")).then(() => parcelRequire('emtky'));